/**
 * 予実表 (Budget) の FE 内部型・定数。
 *
 * 純リファクタで index.tsx から切り出したもの (挙動・構造は完全に元のまま)。
 * BudgetRow など「FE 表示用」の型。API 型 (budgetSlice の BudgetRecord 等) とは別物。
 */

// ── 型定義 ──
export interface BudgetDetailRow {
  id: string;
  label: string;
  /** リンク遷移用 (収入の専有部/付帯設備のみ) */
  sectionId?: string;
  /** section_category code (private_area / common_area / land / facility / other or uuid) */
  sectionCategory?: string;
  /** 収益種別 (rent / ancillary_income / other_income) */
  revenueType?: string;
  months: {
    budget: number | null;
    actual: number | null;
    /** 予実の手動/CSV 実績 (入金管理=actual とは独立)。actual と異なれば項目レベルの ⚠️。 */
    manual_actual?: number | null;
    /**
     * 手動実績の由来 / 競合の解決状態。
     * - "manual": モーダルで手動を採用 (解決済み) → actual と食い違っても ⚠️ を出さない。
     * - "auto"  : インライン入力など未解決 → actual と食い違えば ⚠️。
     */
    actual_source?: "manual" | "auto" | "adjusted";
  }[];
}

export interface BudgetMonthCell {
  // null = 未入力 (表示は "-"/空白)。0 = 明示ゼロ (¥0)。両者を区別する (§7-I)。
  budget: number | null;
  actual: number | null;
  /** 月×フィールド単位の手動上書き状態 (BE 由来) */
  manual_override?: { budget?: boolean; actual?: boolean };
  /**
   * 手動値 vs 積み上げ(明細合計) の競合をモーダルで手動採用(解決)したか (BE 由来)。
   * true のフィールドは食い違っても ⚠️ を出さない。
   */
  override_resolved?: { budget?: boolean; actual?: boolean };
}

export type BudgetGroup =
  | "income"
  | "expense"
  | "expense_opex"
  | "expense_capex"
  | "loan";

export interface BudgetRow {
  id: string;
  category: string;
  /** BudgetCategory.category_id。収入の上位カテゴリ (revenue_group) 解決に使う */
  categoryId?: string;
  group: BudgetGroup;
  months: BudgetMonthCell[];
  details?: BudgetDetailRow[];
}

// ── Props ──
export interface BudgetProps {
  propertyId: string;
  propertyName: string;
}

export type BudgetFormValues = {
  fiscalYear: string;
  viewMode: string;
};

export type PendingDetailOverflowUpdate = {
  sortKey: string;
  detailId: string;
  monthKey: string;
  field: "budget" | "actual";
  amount: number;
  categoryName: string;
  categoryLimit: number;
  detailTotalAfter: number;
};

export const VIEW_MODE_OPTIONS = [
  { value: "monthly", label: "月次" },
  { value: "quarterly", label: "四半期" },
];
